import { ValueColumnField } from '../ValueColumnField';

import styles from './WarehouseValueColumnField.module.css';

interface WarehouseValueColumnFieldProps {
  dataSourceKey?: string;
}

export const WarehouseValueColumnField: React.FC<WarehouseValueColumnFieldProps> = ({ dataSourceKey }) => (
  <div className={styles.fieldWidth}>
    <ValueColumnField key={dataSourceKey} name="valueColumn" dataSourceKey={dataSourceKey} />
  </div>
);
